function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill: red;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Design Convert",
  id: "Design_Convert"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M32,57A25,25,0,1,1,57,32,25,25,0,0,1,32,57ZM32,9A23,23,0,1,0,55,32,23,23,0,0,0,32,9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M43,44a1,1,0,0,1-.71-.29l-22-22a1,1,0,0,1,1.42-1.42l22,22a1,1,0,0,1,0,1.42A1,1,0,0,1,43,44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M21,44a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42l22-22a1,1,0,0,1,1.42,1.42l-22,22A1,1,0,0,1,21,44Z"
}));

var SvgFailureDownloadFile = function SvgFailureDownloadFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "failure-icon",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), _ref2, title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFailureDownloadFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/failure-download-file.ac30b5b6.svg";
export { ForwardRef as ReactComponent };